import Flex from "antd/es/flex";
import {useEffect, useRef, useState} from "react";
import "./styles/queue.less"
import QueueHeader from "./QueueHeader";
import {Button, Col, Row} from "antd";
import QueueItem from "./QueueItem";
import dayjs from "dayjs";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import Search from "antd/lib/input/Search";
import {getRequest, getRequestWithParams} from "../../api/httpRequest";
import {getBaseUrl} from "../../api/axiosInstance";

interface IQueueWaiting {
    talon: string,
}

interface IQueueCalled {
    talon: string,
    cabin: string,
    alert: boolean,
    update: boolean,
    time: string
}

interface IQueue {
    called: IQueueCalled[],
    sound: string,
    waiting: IQueueWaiting[]
}

interface ITalon {
    talon: string,
    status: string,
}

export default function QueuePage() {

    const [queue, setQueue] = useState<IQueue | null>(null);
    const [searchTalon, setSearchTalon] = useState<ITalon | null>(null);
    const {xl} = useBreakpoint();
    const [loading, setLoading] = useState(false);
    const [sound, setSound] = useState<string>("");
    const soundRef = useRef<HTMLAudioElement>();

    const SOUND_URL = "/queue.mp3";

    useEffect(() => {
        dayjs().locale("ru")
        const subscribe = () => {
            let delay = 5000
            try {
                getRequest("/server/queue")
                    .then(response => {
                        const data = response.data;
                        const audio = new Audio(`${getBaseUrl()}${SOUND_URL}`)
                        audio.loop = false;
                        soundRef.current = audio
                        const alerted = data.called.find((call: IQueueCalled) => {
                            if (!call.alert) {
                                return false
                            }
                            const deadLine = dayjs().subtract(6, "seconds")
                            const calledTime = dayjs(call.time)
                            const alertTime = deadLine.isBefore(calledTime) || deadLine === calledTime
                            console.log('-------------------')
                            console.log(call.alert);
                            console.log(alertTime)
                            console.log('-------------------')
                            return call.alert && alertTime
                        })
                        console.log(alerted)
                        if (alerted) {
                            console.log('alerted')
                            console.log(soundRef)
                            soundRef.current?.play().catch((error) => {
                                console.log(error);
                            })
                        } else {
                            soundRef.current?.pause()
                        }
                        setQueue(data)
                        setTimeout(() => {
                            subscribe()
                        }, delay)
                    })
                    .catch(error => {
                        setTimeout(() => {
                            subscribe()
                        }, delay)
                    })

            } catch (error) {
                setTimeout(() => {
                    subscribe()
                }, delay)
            }
        }

        if (loading) {
            subscribe()
        }
    }, [loading]);

    const onSearch = (value: string) => {
        getRequestWithParams("/server/queue", {talon: value})
            .then(response => {
                setSearchTalon(response.data.talon)
            })
    }

    return (
        <Flex className="queue-page" vertical={true}>
            <QueueHeader/>
            {!loading ?
                <Flex style={{width: "100%", height: "100%"}} justify={"center"} align={"center"}>
                    <Button style={{
                        fontSize: "2rem",
                        padding: xl ? "5rem" : "2rem",
                        color: "white",
                        backgroundColor: "#163E73"
                    }}
                            onClick={() => {
                                setLoading(!loading)
                            }}>Запуск очереди</Button>
                </Flex> :
                <>
                    {!xl &&
                        <Flex style={{width: "100%", padding: "1rem"}} justify={"center"} align={"center"}>
                            <Flex style={{width: "80%"}} justify={"center"} align={"center"} vertical={true} gap={8}>
                                <Search placeholder="Введите номер талона" onSearch={onSearch} enterButton/>
                                {searchTalon &&
                                    <div style={{
                                        fontSize: "1.5rem",
                                        color: "#163E73"
                                    }}>{searchTalon.talon} - {searchTalon.status}</div>}
                            </Flex>
                        </Flex>}

                    <Flex style={{width: "100%", height: "85%"}} justify={"center"} align={"center"} vertical={!xl}>
                        <Flex style={{width: xl ? "70%" : "90%", height: "100%"}} justify={"center"} align={"center"}
                              vertical={true} gap={16}>
                            <Flex style={{width: "100%"}} justify={"center"} align={"center"}>
                                <div style={{fontSize: xl ? "3rem" : "1rem", color: "#163E73"}}>Вызванные
                                    талоны:
                                </div>
                            </Flex>
                            <Row style={{width: xl ? "80%" : "100%", height: xl ? "100%" : ""}} gutter={[16, 16]}
                                 align={"middle"} justify={"start"}>
                                {queue?.called.map((item, index) => (
                                    <Col style={{width: "50%", height: "15%", padding: "10px"}} key={index}>
                                        <QueueItem alert={item.alert}
                                                   number={item.talon}
                                                   window={item.cabin}/>
                                    </Col>
                                ))}
                            </Row>
                        </Flex>
                        {xl &&
                            <div className={xl ? "queue-divider" : "queue-divider-mobile"}></div>}
                        <Flex style={{
                            fontFamily: "Verdana, Geneva",
                            width: xl ? "30%" : "90%",
                            height: "95%",
                            fontSize: xl ? "4rem" : "2rem",
                            color: "#163E73"
                        }}
                              vertical={true}
                              justify={"flex-start"}
                              align={"center"}>
                            <div style={{fontSize: xl ? "2rem" : "1rem"}}>Ожидающие обслуживания:
                            </div>
                            <Flex style={{height: "100%"}} vertical={true}>
                            {queue?.waiting.map((item, index) => {
                                if (index < 7) {
                                    return <Flex key={index}>{item.talon}</Flex>
                                }
                            })}
                            </Flex>
                        </Flex>
                    </Flex>
                </>
            }
        </Flex>
    )
}